module.exports = __webpack_public_path__ + "img/20a)Mercatorhalle in Duisburg.jpg";